import React, { useEffect, useState } from "react";
import TextFieldVariable from "./TextFieldVariable";
import _ from "lodash";
import TextFieldVarValues from "./TextFieldVarValues";
import { extractNumberedVariables } from "../utils/util";

function TextFieldTest() {
  const [bodyText, setBodyText] = useState("");
  return (
    <div style={{ padding: "20px" }}>
      <TextFieldVariable
        value={bodyText}
        onParamChange={(newV) => {}}
        onChange={(newV) => {
          setBodyText(newV);
        }}
      />
    </div>
  );
}

export default TextFieldTest;
